import { Table } from "antd";
import { get } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../../../utils/utilities";

export default function ExternalRate(props) {
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));

  const columns = [
    {
      title: t("projectsManagement.team.tables.internal&external.serviceResource"),
      dataIndex: "serviceId",
      width: 200,
      fixed: "left",
    },
    {
      title: t("projectsManagement.team.tables.internal&external.budget"),
      dataIndex: "basePrice",
      width: 100,
      fixed: "left",
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.gen"),
      dataIndex: ["consValue", "JANUARY"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.feb"),
      dataIndex: ["consValue", "FEBRUARY"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.mar"),
      dataIndex: ["consValue", "MARCH"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.apr"),
      dataIndex: ["consValue", "APRIL"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.may"),
      dataIndex: ["consValue", "MAY"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.jun"),
      dataIndex: ["consValue", "JUNE"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.jul"),
      dataIndex: ["consValue", "JULY"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.aug"),
      dataIndex: ["consValue", "AUGUST"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.sep"),
      dataIndex: ["consValue", "SEPTEMBER"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.oct"),
      dataIndex: ["consValue", "OCTOBER"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.nov"),
      dataIndex: ["consValue", "NOVEMBER"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
    {
      title: t("projectsManagement.team.tables.internal&external.dec"),
      dataIndex: ["consValue", "DECEMBER"],
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage }),
    },
  ];

  return (
    <>
      <Table pagination={false} columns={columns} dataSource={props.data} scroll={{ x: 1250 }} size="small" bordered />
    </>
  );
}
